import { Icon } from './Icon';

type XIconProps = React.ComponentProps<typeof Icon>;

export const XIcon = (props: XIconProps) => (
  <Icon boxSize="1em" {...props}>
    <svg viewBox="0 0 30 30">
      <circle cx="15" cy="15" r="15" fill="currentColor" />
      <path
        d="M17.3508 13.7749L23.3071 7H21.8957L16.7238 12.8826L12.593 7H7.82861L14.0752 15.8955L7.82861 23H9.24016L14.7018 16.7878L19.0642 23H23.8286L17.3504 13.7749H17.3508ZM15.4175 15.9738L14.7846 15.0881L9.74876 8.03974H11.9168L15.9808 13.728L16.6137 14.6137L21.8963 22.0075H19.7283L15.4175 15.9742V15.9738Z"
        fill="black"
      />
    </svg>
  </Icon>
);
